module.exports = __webpack_public_path__ + "img/shipments.a88b7873.png";